<template>
  <div id="app">
    <img alt="Vue logo" src="./assets/logo.png">
    <HelloWorld msg="Welcome to Your Vue.js App"/>
  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'
import BarCamp from './components/data.vue'

var tabletop = Tabletop.init({ 
  key: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vRdbAPXsdmWxjsShcyXz3CKdJ1pw-vpkhXOtVilHMpNHC1pdBNTpTdcxnAteAfPQTAaoMl_ah4yflrs/pubhtml?widget=true&amp;headers=false', 
  callback: showInfo
})

export default {
  name: 'app',
  components: {
    HelloWorld,
    BarCamp
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
